module Cfnc.Controller {
    "use strict";

    interface IHomeScope extends ng.IScope {
        vm: Home;
    }

    interface IHome {

    }

    class Home implements IHome {
        static controllerId: string = "home";
        static $inject: Array<string> = ["common", "$window", "config"];
        private log;

        constructor(private common: ICommonFactory, private $window: ng.IWindowService, private config: IConfig) {
            this.log = common.logger.getLogFn(Home.controllerId);
            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, Home.controllerId)
                .then(() => {
                    this.log("Activated Home View", false);
                    if (this.config.homeRedirect)
                        this.$window.location.href = this.config.umbracoUrl;
                });
        }
    }

    angular.module("app").controller(Home.controllerId, Home);
}